module.exports = __webpack_public_path__ + "img/sample-user.44d7986c.png";